import $ from 'jquery';
import Clipboard from 'clipboard';
import { METHODS, v2Endpoint } from '@pcs/pulse-components';
import loadItemsTemplateFn from '../templates/common/load-items.hbs';
import utilities from './utilities';

window.Clipboard = Clipboard;

$(document).ready(async function() {

    /*
        Javascript is loaded
    */

    $('html').addClass('js-loaded');

    /*
        INIT lightbox if not dynamically loaded
    */


    // handles the change event of select elements that contain an empty option as a placeholder
    $(document).on('change', 'select.contains-placeholder,select.contained-placeholder', event => {
        // reference the current target select as a jquery object
        const select = $(event.currentTarget);
        // toggle the aesthetic classes accordingly
        if (select.val() === '') {
            select.addClass('contains-placeholder').removeClass('contained-placeholder');
        } else {
            select.addClass('contained-placeholder').removeClass('contains-placeholder');
        }
    });

    // Check for width of navs on passport
    // When screen is too small to fit the menu then a more button is created.
    function v3TabResize() {
        let $more = $('#tabs-nav.v3-tabs_nav .toggle-more');
        if($more.length > 0) {
            let navwidth = 0;
            let morewidth = $more.is(':visible') ? $more.outerWidth(true) : 0;

            $('#tabs-nav > a:not(.toggle-more)').each(function() {
                navwidth += $(this).outerWidth( true );
            });

            let availablespace = $('nav').outerWidth(false) - morewidth;

            let ukDropdown = $more.next('div[uk-dropdown]').find('div.v3-tabs_extends');
            if (navwidth > availablespace) {

                let lastItem = $('#tabs-nav.v3-tabs_nav > a:not(.toggle-more)').last();
                lastItem.attr('data-width', lastItem.outerWidth(true));
                lastItem.prependTo(ukDropdown);

                setTimeout(function() {
                    v3TabResize();
                }, 30);
            } else {
                let firstMoreElement = $more.next('div[uk-dropdown]').find('a.v3-tabs_nav-item').first();
                if (navwidth + firstMoreElement.data('width') < availablespace) {
                  firstMoreElement.insertBefore($more);
                    // check width again
                    v3TabResize();
                }
            }

            if (ukDropdown.find('a').length > 0) {
                $more.removeClass('uk-hidden');
            } else {
                $more.addClass('uk-hidden');
            }
        }
    }

    v3TabResize();

    function calcWidth() {

        let $more = $('#tabs-nav .more');

        if($more.length > 0) {
            let navwidth = 0;
            let morewidth = $more.is(':visible') ? $more.outerWidth(true) : 0;

            $('#tabs-nav > li:not(.more)').each(function() {
              navwidth += $(this).outerWidth( true );
            });

            let availablespace = $('nav').outerWidth(false) - morewidth;

            if (navwidth > availablespace) {
                let lastItem = $('#tabs-nav > li:not(.more)').last();
                lastItem.attr('data-width', lastItem.outerWidth(true));
                lastItem.prependTo($more.find('ul'));
                lastItem.find('.active').addClass('border-bottom-active')
                setTimeout(function() {
                    calcWidth();
                }, 30);
            } else {

                let firstMoreElement = $more.find('li').first();
                if (navwidth + firstMoreElement.data('width') < availablespace) {
                  firstMoreElement.insertBefore($more);
                    //   check width again
                    calcWidth();
                }
            }

            if ($more.find('li').length > 0) {
                $more.css('display','inline-block');
            } else {
                $more.css('display','none');
            }
        }
    }

    // Sometimes there is a delay with window.load so lets do it on docujment ready
    // First just in case
    calcWidth();
    
    // Trigger the function to calculate the width of the nav
    // when the window loads
    // Recalc the width = 1 as each menu item is moved to more items
    $(window).on('load',function () {
        calcWidth();
        v3TabResize();
    });

    // Trigger the function to calculate the width of the nav
    // when the window resizes
    // Recalc the width = 0 since it will work incrementallyy when the window is resized
    $(window).on('resize', _.debounce(function() {
        calcWidth();
        v3TabResize();
    }, 200));

    // Used to load recent projects and favourite projects in sidebar menu
    // data action needs to matc the endpoint eg get-recent-projects
    // and the template needs to match this also untila  time when all fo the endpoints return the same data
    // Favourites and Recent Projects should not link to anywhere
    $('[data-action="get-my-favourites"], [data-action="get-recent-projects"]').removeAttr('href');

     $( ".load-items").on('mouseenter', function() { 
         loadItems($(this));
    });

    $('.mobile-icon-toggle').on('click', function () {
        let $target = $(this).closest('li').find('.load-items');        
        loadItems($target);
    });

    function loadItems($target) {

        $.each($target, function () {

            let action = $(this).attr('data-action');
            let id = $(this).attr('data-id');

            if (action) {

                if($(this).parent().find("[data-container='" + id + "'] li").length < 1) {
                    let endPoint = window.pulse.config.urls.api;
                    let params = {
                        action: 'sidebar',
                        type: action,
                        limit: 20
                    }
                    let request;
                    request = $.get(endPoint, params);
                    request.done(function(data) {
                        $("[data-container='" + id + "']").html(loadItemsTemplateFn({
                            items: data.data,
                            urls: window.pulse.config.urls
                        }));  
                    });
                    request.fail(function(e) {
                        console.log(e);
                    })
                }
            }    
        });
    }
    
    /*!
  Non-Sucking Autogrow 1.1.6
  license: MIT
  author: Roman Pushkin
  https://github.com/ro31337/jquery.ns-autogrow
*/
(function(){let e;!function(t,l){return t.fn.autogrow=function(i){if(null==i&&(i={}),null==i.horizontal&&(i.horizontal=!0),null==i.vertical&&(i.vertical=!0),null==i.debugx&&(i.debugx=-1e4),null==i.debugy&&(i.debugy=-1e4),null==i.debugcolor&&(i.debugcolor="yellow"),null==i.flickering&&(i.flickering=!0),null==i.postGrowCallback&&(i.postGrowCallback=function(){}),null==i.verticalScrollbarWidth&&(i.verticalScrollbarWidth=e()),i.horizontal!==!1||i.vertical!==!1)return this.filter("textarea").each(function(){var e,n,r,o,a,c,d;if(e=t(this),!e.data("autogrow-enabled"))return e.data("autogrow-enabled"),a=e.height(),c=e.width(),o=1*e.css("lineHeight")||0,e.hasVerticalScrollBar=function(){return e[0].clientHeight<e[0].scrollHeight},n=t('<div class="autogrow-shadow"></div>').css({position:"absolute",display:"inline-block","background-color":i.debugcolor,top:i.debugy,left:i.debugx,"max-width":e.css("max-width"),padding:e.css("padding"),fontSize:e.css("fontSize"),fontFamily:e.css("fontFamily"),fontWeight:e.css("fontWeight"),lineHeight:e.css("lineHeight"),resize:"none","word-wrap":"break-word"}).appendTo(document.body),i.horizontal===!1?n.css({width:e.width()}):(r=e.css("font-size"),n.css("padding-right","+="+r),n.normalPaddingRight=n.css("padding-right")),d=function(t){return function(l){var r,d,s;return d=t.value.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\n /g,"<br/>&nbsp;").replace(/"/g,"&quot;").replace(/'/g,"&#39;").replace(/\n$/,"<br/>&nbsp;").replace(/\n/g,"<br/>").replace(/ {2,}/g,function(e){return Array(e.length-1).join("&nbsp;")+" "}),/(\n|\r)/.test(t.value)&&(d+="<br />",i.flickering===!1&&(d+="<br />")),n.html(d),i.vertical===!0&&(r=Math.max(n.height()+o,a),e.height(r)),i.horizontal===!0&&(n.css("padding-right",n.normalPaddingRight),i.vertical===!1&&e.hasVerticalScrollBar()&&n.css("padding-right","+="+i.verticalScrollbarWidth+"px"),s=Math.max(n.outerWidth(),c),e.width(s)),i.postGrowCallback(e)}}(this),e.change(d).keyup(d).keydown(d),t(l).resize(d),d()})}}(window.jQuery,window),e=function(){var e,t,l,i;return e=document.createElement("p"),e.style.width="100%",e.style.height="200px",t=document.createElement("div"),t.style.position="absolute",t.style.top="0px",t.style.left="0px",t.style.visibility="hidden",t.style.width="200px",t.style.height="150px",t.style.overflow="hidden",t.appendChild(e),document.body.appendChild(t),l=e.offsetWidth,t.style.overflow="scroll",i=e.offsetWidth,l===i&&(i=t.clientWidth),document.body.removeChild(t),l-i}}).call(this);

    /*
        Toggle classes
    */

    $(document).on('click', '.toggle-height', function() {
        var target = $(this).attr('data-target');
        $('#' + target).toggleClass('auto-height');
    });

    $(document).on('click', '[data-hide]', function() {
        var target = $(this).attr('data-hide');
        $('#' + target).hide();
    });

    $(document).on('click', '.hide-this', function() {
        $(this).addClass('uk-hidden');
    });

    $(document).on('change', 'select.toggle', function() {
        var target = $(this).attr('data-target');
        $('[data-id="' + target + '"]').fadeIn();
    });

    $(document).on('click', 'a.toggle,h3.toggle,span.toggle,button.toggle', function(e) {

        var target = $(this).attr('data-target');
        var related = $(this).attr('data-related');
        var active_text = $(this).attr('data-active');
        var inactive_text = $(this).attr('data-inactive');

        // Target icon only
        var icon = 0;

        if ($(this).hasClass('hide-self')) {
            $(this).fadeOut();
        }

        if ($(this).hasClass('icon')) {
            var icon = 1;
        }
        // Close all
        if ($(this).hasClass('toggle-all')) {

            // Hide all
            $(this).parent().find('.toggle-content').slideUp();

            // Is already active so slides up
            if ($(this).hasClass('active')) {
                 $(this).parent().parent().find('.toggle-all').removeClass('active');
            } else {
                // Isnt active so slide down
                $('[data-id="' + target + '"]').slideDown('fast');
                $(this).parent().parent().find('.toggle-all').removeClass('active');
                $(this).addClass('active');
            }

        } else if($(this).hasClass('toggle-block')) {
            $('a.toggle-block').removeClass('active');
            $(this).addClass('active');

            $('div.toggle-block').hide();
            $('[data-id="' + target + '"]').slideToggle('fast');

       } else {

             $(this).toggleClass('active');
             $('[data-id="' + target + '"]').slideToggle('fast');

         }

         if ($(this).hasClass('hide-parent')) {
             $(this).parent().fadeOut();
         }

         if (typeof active_text !== "undefined") {
             if (icon) {
                 if ($(this).hasClass('active')) {
                     $(this).find('.fa').addClass(active_text);
                 } else {
                     $(this).find('.fa').removeClass(active_text);
                 }
             } else {
                 if ($(this).hasClass('active')) {
                     $(this).html(active_text);
                 } else {
                     $(this).html(inactive_text);
                 }
             }
         }

        if ($(this).hasClass('scroll')) {
            $('html, body').animate({
                 scrollTop: $(this).offset().top - 120
            }, 500);
        }
     });

    // Expand collapse tree menuitem
    $(document).on('click', '[data-action="expand-tree"]', function() {
       $('#tree-list ul input').prop('checked', true);
       $('#tree-list label').addClass('active');
       $('#tree-list ul ul').slideDown();
    });

    $(document).on('click', '[data-action="collapse-tree"]', function() {
       $('#tree-list ul input').prop('checked', false);
       $('#tree-list label').removeClass('active');
       $('#tree-list ul ul').slideUp();
    });

    // // Animation on inputs with icons
    $(document).on('focusin', ".input-with-icon", function() {
        $( this ).find( "span" ).animate({"opacity":"0"}, 200);
        $( this ).find( "button" ).addClass('is-visible');
    });

    $(document).on('focusout', ".input-with-icon", function() {
         $( this ).find( "span" ).animate({"opacity":"1"}, 300);
         $( this ).find( "button" ).removeClass('is-visible');
    });

    // Trigger top Global search bar
    $('.global-search, #search-query').on('keyup', function(e) {
        e.preventDefault(); 
        let enterKeyPressed = e.which === 13;

        if (!enterKeyPressed) {
          return false; 
        }

        let searchTerm = $(this).val();
        
        if ($.trim(searchTerm) !== '') {
          window.location.href = window.pulse.config.urls.app + "search?q=" + encodeURIComponent(searchTerm);
        }  
    });

    $('.trigger-search-btn,.mobile-trigger-search-btn').on('click', function(e) {
        e.preventDefault(); 
        const $input = $(this).closest('div').find('input.global-search');
        const searchTerm = $input.val();

        if (searchTerm === "") {
            $input.focus();
            return false;
        }
        if ($.trim(searchTerm) !== '') {
            window.location.href = window.pulse.config.urls.app + "search?q=" + encodeURIComponent(searchTerm); 
        }
    });

    $('[data-action="favourite-project"]').on('click', function() {

        let favButton = '[data-action="favourite-project"]';
        if($(this).hasClass('active')) {
            var action = "remove-from-favourites";
        } else {
            var action = "add-to-favourites";
        }
        $.ajax({
            type: 'POST',
            url: window.pulse.config.urls.pulse + 'ajax.php',
            data: {
                action: action,
                fk: $('html').attr('data-job-id'),
                table: "job"
            }
        }).error(function() {
            utilities.dismissNotifications();
            utilities.notify({
                message: 'There was an error favouriting this project. <br />Please try again',
                status: 'warning',
                timeout: 4000,
                pos: 'top-center'
            });
        }).success(function() {
            let message = 'Project added to favourites';
            if(action == "add-to-favourites") {
                $(favButton).addClass('active');
                $(favButton).find('.link-title').text('Remove from Favourites')
            } else {
                $(favButton).removeClass('active');
                message = 'Project removed from favourites';
                $(favButton).find('.link-title').text('Add to Favourites');
            }
            utilities.dismissNotifications();
            utilities.notification.success(message);
        });
    });

    let cp = new Clipboard('.copy');
    cp.on('success', function(e) {
        utilities.notification.success('Copied to clipboard');
    });

});

